import React from 'react';
import { cn } from '../../lib/utils';

interface SkeletonProps {
  className?: string;
}

export const Skeleton = ({ className }: SkeletonProps) => {
  return (
    <div className={cn("inline-block h-full w-full animate-pulse rounded-md bg-slate-200/60", className)} />
  );
};

export const ProductSkeleton = () => {
  return (
    <div className="bg-white rounded-[3rem] border border-slate-100 p-8 space-y-6">
      <Skeleton className="aspect-[4/3] rounded-[2.5rem]" />
      <div className="space-y-4">
        <div className="flex gap-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="w-4 h-4 rounded-full" />
          ))}
        </div>
        <Skeleton className="h-8 w-3/4 rounded-xl" />
        <Skeleton className="h-4 w-1/4 rounded-lg" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-full rounded-lg" />
          <Skeleton className="h-4 w-5/6 rounded-lg" />
        </div>
        <div className="flex justify-between items-center pt-4">
          <Skeleton className="h-10 w-24 rounded-2xl" />
          <Skeleton className="h-14 w-32 rounded-2xl" />
        </div>
      </div>
    </div>
  );
};

export const CategorySkeleton = () => {
  return (
    <div className="h-64 rounded-[2rem] overflow-hidden">
      <Skeleton className="h-full w-full" />
    </div>
  );
};
